// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
// cmd: ng build -e web1 

export const environment = {
    production: true,
    // api_url: 'https://na1.salesnow.com/api/rest/SalesNOW.svc',
    // service_url: "https://na1.salesnow.com/api/rest/SNService.svc",
    api_url: 'https://web1.salesnow.com/api/spa_dev/SalesNOW.svc',
    service_url: "https://web1.salesnow.com/api/spa_dev/SNService.svc",
    web3_api_url: 'https://web1.salesnow.com/api/spa/SalesNOW.svc',
    sn_url: 'https://web1.salesnow.com',
    bi_url: "https://bi.salesnow.com/bi",
    bi_site_url: "/site/salesnow",
    bi_auth_Url: "/bi/sf/get_details",
    title: 'U.S. Cellular - Making Sales Happen',
    version: '2024.05.09.1'
};



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/environments/environment.ts